import {
  makeStyles,
  IconButton,
  FormControl,
  OutlinedInput,
  InputAdornment,
} from '@material-ui/core';

import Icon from 'components/Icon';

const useStyles = makeStyles((theme) => ({
  search: {
    display: 'flex',
    flexDirection: 'row',
    boxShadow: '0px 0px 8px rgba(45, 53, 67, 0.12)',
    borderRadius: '0 24px 24px 0',
    borderWidth: 0,
    '& .MuiInputBase-root': {
      paddingRight: '0px',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e9ecf1',
      },
    },
    '& .MuiInputBase-input': {
      height: 40,
      padding: '0 12px 0 12px',
      fontWeight: 500,
      fontSize: 16,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '4px 24px 24px 4px',
      borderRight: 'none',
      paddingRight: '0px',
      border: '1px solid transparent !important',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: 1,
      borderColor: '#e9ecf1',
    },
  },
  button: {
    background: '#fff',
    width: 40,
    height: 40,
    padding: 8,
    border: `2px solid ${theme.palette.primary.main}`,
    position: 'absolute',
    right: 0,
    zIndex: 1,
  },
}));

const HeaderSearchField = (props) => {
  const {
    placeholder = 'Search',
    fullWidth = true,
    buttonProps,
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <FormControl
      size="small"
      variant="outlined"
      fullWidth={fullWidth}
      className={classes.search}
    >
      <OutlinedInput
        placeholder={placeholder}
        fullWidth={fullWidth}
        {...rest}
        endAdornment={
          <InputAdornment position="end">
            <IconButton className={classes.button} {...buttonProps}>
              <Icon.SearchTarget />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

export default HeaderSearchField;
